












































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import NotificationsBell from '@/modules/notification/components/shared/NotificationsBell.vue'
import UserDropdown from '@/modules/common/layout/components/shared/UserDropdown.vue'
import UserService from '@/modules/user/services/user.service' //todo moveTo
import { PanelLayoutRoute } from '@/modules/common/layout/routes/panel-layout.route'
import dayjs from 'dayjs'
import Today from '@/modules/common/layout/components/shared/Today.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import TelegramActivationButton from '@/modules/shared/components/panel/TelegramActivationButton.vue'
import { VerificationStatusModel } from '@/modules/common/layout/components/panel/PanelLayout.vue'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'

@Component({
  components: { TelegramActivationButton, TextEllipsis, Today, UserDropdown, NotificationsBell }
})
export default class PanelTopHeader extends Vue {
  constructor(
    private readonly userService: UserService,
    private readonly routes: PanelLayoutRoute,
    private readonly userBootUseCase: UserBootUseCase
  ) {
    super()
  }

  @Prop() wallet_amount!: number | 0
  @Prop() unreadNotifications!: number
  @Prop() orig_user!: string | null
  @Prop() verification_status!: VerificationStatusModel
  @Prop() current_user!: object
  showDrawer = !this.$q.screen.lt.md
  private shadow = false

  @Watch('current_user', { immediate: true })
  onUrlChange() {
    this.showDrawer = !this.$q.screen.lt.md
  }

  get user() {
    return this.userService.user
  }

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  }

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    this.shadow = window.scrollY > 0
  }

  time = dayjs().format('DD MMMM، YYYY')

  toggleDrawer() {
    this.showDrawer = true
    this.$emit('toggleDrawer')
  }
}
